<template>
  <v-container class="grey lighten-5">
    <v-card :elevation="4" class="pa-2">
      <v-row justify="center">
        <v-col class="mb-12">
          <div v-if="singleFecha">
            <v-select
              v-model="select0"
              :items="empresas"
              item-text="nombre"
              item-value="id"
              label="Seleccione sede"
              required
              @change="getEmpresadetails"
            ></v-select>

            <v-col>
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :return-value.sync="date"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="date"
                    label="Seleccione fecha Desde"
                    prepend-icon="mdi-calendar-account"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="date" no-title scrollable locale="es">
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="menu = false"
                    >Cancel</v-btn
                  >
                  <v-btn text color="primary" @click="$refs.menu.save(date)"
                    >OK</v-btn
                  >
                </v-date-picker>
              </v-menu>

              <v-menu
                ref="menu2"
                v-model="menu2"
                :close-on-content-click="false"
                :return-value.sync="date2"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="date2"
                    label="Seleccione fecha Hasta"
                    prepend-icon="mdi-calendar-account"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="date2" no-title scrollable locale="es">
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="menu2 = false"
                    >Cancel</v-btn
                  >
                  <v-btn text color="primary" @click="$refs.menu2.save(date2)"
                    >OK</v-btn
                  >
                </v-date-picker>
              </v-menu>
            </v-col>
          </div>

          <v-btn @click="getRegistros" block color="primary"
            >TRAER REGISTROS</v-btn
          >
        </v-col>
      </v-row>
    </v-card>

    <br />

    <v-dialog v-model="dialog" max-width="400">
      <v-card>
        <v-card-title class="headline">Reactivacion de usuarios</v-card-title>

        <v-card-text>
          Desea reactivar el usuario {{ nombre }} de nuevo ?
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="green darken-1" text @click="dialog = false">
            Cancelar
          </v-btn>

          <v-btn color="green darken-1" text @click="activateUserAgain">
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-card :elevation="4" class="pa-2">
      <v-row justify="center">
        <v-col class="mb-12">
          <div class="text-center">
            <h2>HISTORICO DE DOMICLIOS</h2>
            <br />
          </div>

          <v-card>
            <v-data-table
              v-model="selected3"
              :headers="headers3"
              :items="tabla3"
              :single-select="true"
              item-key="id"
              show-select
              :items-per-page="30"
              class="elevation-1"
              @click:row="getRecords"
            >
            </v-data-table>

            <div class="text-center pt-2">
              <v-pagination
                v-model="page"
                :length="pageCount"
                @input="onPageChange"
              ></v-pagination>

              <br /><br />

              <div class="text-center">
                <h2>DETALLE DE DOMICLIOS</h2>
                <br />
              </div>

              <v-data-table
                v-model="selected4"
                :headers="headers4"
                :items="tabla4"
                item-key="id"
                :items-per-page="30"
                class="elevation-1"
              >
              </v-data-table>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import axios from "axios";
import { actionStore } from "./CheckerLocalStorage";
import Tabla from "./Tabla";

export default {
  components: {
    Tabla
  },

  data: vm => ({
    date2: new Date().toISOString().substr(0, 10),

    singleFecha: true,
    radioGroup4: 0,
    dialog: false,
    date: new Date().toISOString().substr(0, 10),
    dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
    menu1: false,
    menu2: false,
    e4: null,
    dropdown_font: ["Arial", "Calibri", "Courier", "Verdana"],
    perfiles: [{ id: 1, nombrePerfilCargo: "one" }],
    cargoNombre: [{ id: 1, nombrePerfilCargo: "one" }],
    fecha: "",
    empresas: [{ id: 1, nombrePerfilCargo: "one" }],
    select0: null,
    select1: null,
    select2: null,
    select3: null,
    cedula: "",
    nombre: "",
    pagination: "",
    statusFailure: false,
    statusEmpty: false,
    statusCreated: false,
    search: "",
    selected: [],
    selected2: [],
    selected3: [],
    selected4: [],
    singleSelect: true,
    singleSelect2: true,
    singleSelect3: true,
    empresaSelected: {},
    statusLoader: false,
    menu: false,

    hora: "",
    url1: "",

    //*******TABLE PAGINATION */
    page: 0,
    pageCount: 0,
    itemsPerPage: 10,
    headers: [
      { text: "NombreUsuario", value: "nombreusuario" },
      { text: "Cedula", value: "cedula" },
      { text: "Cargo", value: "nombrecargo" },
      { text: "Perfil", value: "nombreperfil" },
      { text: "Fecha y hora", value: "fecha" }
    ],
    tabla: [],

    //*******TABLE PAGINATION */

    //*******TABLE PAGINATION */
    page2: 0,
    pageCount2: 0,
    itemsPerPage2: 10,
    headers2: [
      { text: "NombreUsuario", value: "nombreusuario" },
      { text: "Cedula", value: "cedula" },
      { text: "Cargo", value: "nombrecargo" },
      { text: "Perfil", value: "nombreperfil" },
      { text: "Fecha y hora", value: "fecha" }
    ],
    tabla2: [],

    //*******TABLE PAGINATION */

    //*******TABLE PAGINATION */
    page3: 0,
    pageCount3: 0,
    itemsPerPage3: 10,
    headers3: [
      { text: "ID", value: "idDomicilio" },
      { text: "ACTIVO", value: "activo" },
      { text: "SEDE", value: "sede" },
      { text: "CEDULA", value: "cedula" },
      { text: "NOMBRE", value: "nombre" },
      { text: "CANTIDAD DOMICILIOS", value: "cantidadDomicilios" },
      { text: "VALOR DOMICILIOS", value: "valorDomicilios" },
      { text: "FECHA HORA SALIDA", value: "fechaHoraSalida" },
      { text: "FECHA HORA ENTRADA", value: "fechaHoraEntrada" },
      { text: "T. HORAS", value: "thoras" },
      { text: "T. MINUTOS", value: "tminutos" }
    ],
    tabla3: [],

    //*******TABLE PAGINATION */

    headers4: [
      { text: "NOMBRE BARIO", value: "nombrebarrio" },
      { text: "VALOR DOMICILIO", value: "valordomicilio" }
    ],
    tabla4: []
  }),

  computed: {
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
    msg() {
      const selectedRow = this.selected[0];
      console.log(selectedRow);
    }
  },

  watch: {
    date() {
      this.dateFormatted = this.formatDate(this.date);
      this.fecha = "Fecha seleccionada: " + this.dateFormatted;
    },
    e4() {
      this.hora = "Hora seleccionada: " + this.e4;
      console.log("it has cahnged.." + this.e4);
    }
  },

  beforeMount() {
    console.log("URL .." + this.url1);
  },

  mounted() {
    let that = this;

    axios
      .get(
        actionStore.methods.getInfoEmpresa().urlServer +
          "/register/sedes?tenantId=tenantId" +
          actionStore.methods.getInfoEmpresa().tenantId
      )
      .then(function(response) {
        //console.log(response);
        that.empresas = response.data;
      })
      .then();

    /*
        let that = this;

         axios.get(actionStore.methods.getEndpoints().URL_BACKEND+"/info/empresas")
            .then(function (response) {
                //console.log(response);
                that.empresas = response.data;
        }).then();

        */
    /*
        axios.get(this.url1)
            .then(function (response) {
              //  console.log(response);
                that.perfiles = response.data;
        }).then();

        this.fillTable();*/
  },

  methods: {
    getRegistros: function() {
      if (Object.keys(this.empresaSelected).length != 0) {
        let that = this;
        this.url1 =
          actionStore.methods.getInfoEmpresa().urlServer +
          "/register/getalldomicilios/" +
          this.date2 +
          "/" +
          this.date +
          "/" +
          this.empresaSelected.id +
          "/" +
          this.page +
          "?tenantId=tenantId" +
          actionStore.methods.getInfoEmpresa().tenantId;
        console.log(this.url1);
        let salidas = [];
        let entradas = [];
        axios
          .get(this.url1)
          .then(function(response) {
            console.log(response);
            that.pageCount = parseInt(response.data.totalPages);
            that.tabla3 = response.data.infoPermisos;
          })
          .then();
      } else {
        alert("seleccione una sede primero");
      }
    },

    getPorFechahoy: function() {
      if (this.radioGroup4 == 0) {
        this.singleFecha = true;
      } else {
        this.singleFecha = false;
      }
    },

    getEmpresadetails: function() {
      this.empresas.map(item => {
        if (item.id == this.select0) {
          console.log(item);
          this.empresaSelected = item;
        }
      });
    },

    getPerfiles: function() {
      let that = this;
      this.url1 =
        actionStore.methods.getInfoEmpresa().urlServer +
        "/register/perfilcargos?tenantId=tenantId" +
        actionStore.methods.getInfoEmpresa().tenantId;
      axios
        .get(this.url1)
        .then(function(response) {
          //  console.log(response);
          that.perfiles = response.data;
        })
        .then();

      this.fillTable();
    },

    activateUserAgain() {
      this.dialog = false;
      console.log("the ID  is " + this.cedula);
      let that = this;
      let url =
        actionStore.methods.getInfoEmpresa().urlServer +
        "/register/disableuser/" +
        this.cedula +
        "/1?tenantId=tenantId" +
        that.empresaSelected.tenantId;
      axios
        .post(url, {})
        .then(function(response) {
          that.enablingUser();
        })
        .catch(function(error) {
          console.log("from error..*.");
        });
    },

    enablingUser: function() {
      let url =
        actionStore.methods.getEndpoints().URL_BACKEND +
        "/info/updateuser/" +
        this.cedula +
        "/1";

      let that = this;
      console.log(url);
      axios
        .post(url, {})
        .then(function(response) {
          //console.log("updated user..");
          that.fillTable();
          that.statusLoader = false;
        })
        .catch(function(error) {
          console.log("the error is ");
          console.log(error);
        });
    },

    selectedItems: function() {
      console.log(this.selected);

      let that = this;
      this.selected.map(item => {
        let url =
          actionStore.methods.getInfoEmpresa().urlServer +
          "/register/disableuser/" +
          item.cedula +
          "/0?tenantId=tenantId" +
          that.empresaSelected.tenantId;
        axios
          .post(url, {})
          .then(function(response) {
            that.disablingUser(item.cedula, that);
          })
          .catch(function(error) {
            console.log("from error...");
          });
      });
    },

    disablingUser: function(idSelectedUser, that) {
      let url =
        actionStore.methods.getEndpoints().URL_BACKEND +
        "/info/updateuser/" +
        idSelectedUser +
        "/0";
      axios
        .post(url, {})
        .then(function(response) {
          //console.log("updated user..");
          that.fillTable();
        })
        .catch(function(error) {
          console.log("from error...");
        });
    },

    onPageChange: function() {
      //console.log('page '+this.page);
      this.fillTable();
    },

    fillTable: function() {
      let that = this;
      let url =
        actionStore.methods.getInfoEmpresa().urlServer +
        "/register/usuariospaginados/" +
        this.page +
        "?tenantId=tenantId" +
        actionStore.methods.getInfoEmpresa().tenantId;
      axios
        .get(url)
        .then(function(response) {
          that.pageCount = parseInt(response.data.totalPages);
          that.tabla = response.data.infoUsuario;
        })
        .then();
    },
    hideMessage: function() {
      this.statusEmpty = false;
      this.statusCreated = false;
      this.statusFailure = false;
    },

    getCargo: function() {
      this.hideMessage();
      //console.log('cargo selected..'+this.select2);
    },

    getPerfil: function() {
      this.hideMessage();
      console.log("perfil selected.." + this.select1);
      let url =
        actionStore.methods.getInfoEmpresa().urlServer +
        "/register/cargos/" +
        this.select1 +
        "?tenantId=tenantId" +
        actionStore.methods.getInfoEmpresa().tenantId;
      let that = this;
      axios
        .get(url)
        .then(function(response) {
          console.log(response);
          that.cargoNombre = response.data;
        })
        .then();
    },

    finish: function() {
      if (
        this.select1 != "" &&
        this.select2 != "" &&
        this.nombre != "" &&
        this.cedula != ""
      ) {
        let that = this;
        let responsedata = "";
        let cedula1 = this.cedula;
        let nombre1 = this.nombre;

        this.statusLoader = true;
        let url =
          actionStore.methods.getInfoEmpresa().urlServer +
          "/register/checkuser/" +
          cedula1 +
          "?tenantId=tenantId" +
          actionStore.methods.getInfoEmpresa().tenantId;
        //console.log("URL 1 "+url);
        axios.get(url).then(function(response) {
          //console.log(response);
          if (response.data == "EXISTS") {
            console.log("from exists..");
            let url2 =
              actionStore.methods.getInfoEmpresa().urlServer +
              "/register/checkuserstatus/" +
              cedula1 +
              "?tenantId=tenantId" +
              actionStore.methods.getInfoEmpresa().tenantId;

            axios
              .post(url2, {})
              .then(function(response2) {
                if (response2.data == "EXISTS") {
                  console.log("do you want to reactivate the USER again ?");
                  //that.activateUserAgain(cedula1);
                  that.dialog = true;
                } else {
                  that.statusFailure = true;
                  that.statusLoader = false;
                }
              })
              .catch(function(error) {
                //console.log('from error.*..');
              });
          } else {
            let url =
              actionStore.methods.getInfoEmpresa().urlServer +
              "/register/createuser?tenantId=tenantId" +
              actionStore.methods.getInfoEmpresa().tenantId;
            axios
              .post(url, {
                fkIdPerfil: that.select1,
                fkIdCargo: that.select2,
                cedula: that.cedula,
                nombre: that.nombre.toUpperCase(),
                huella: ""
              })
              .then(function(response) {
                //console.log('from success...');
                //console.log(response);
                //console.log(response.data);
                responsedata = response.data;

                that.creatingUser(
                  responsedata,
                  cedula1,
                  nombre1,
                  actionStore.methods.getInfoEmpresa().urlServer,
                  that
                );

                that.cedula = "";
                that.nombre = "";
              })
              .catch(function(error) {
                console.log("from error...");

                if (error.response.status == 302) {
                  that.statusFailure = true;
                  that.statusLoader = false;
                }
              });
          }
        });
      } else {
        //console.log('campos vacios');
        this.statusEmpty = true;
      }
    },

    getRecords: function() {
      let that = this;
      axios
        .get(
          actionStore.methods.getInfoEmpresa().urlServer +
            "/register/getdatailsdomiclio/" +
            this.selected3[0].idDomicilio +
            "?tenantId=tenantId" +
            actionStore.methods.getInfoEmpresa().tenantId
        )
        .then(function(response) {
          console.log(response);
          that.tabla4 = response.data.infoPermisos;
          //that.empresas = response.data;
        })
        .then();
    },

    creatingUser: function(idUser, cedula, nombre, urlServer, that) {
      console.log("calling from second method");

      let url =
        actionStore.methods.getEndpoints().URL_BACKEND +
        "/api/auth/signup/user";
      axios
        .post(url, {
          name: nombre,
          username: cedula,
          email: cedula + "@none.com",
          password: cedula,

          fkIdTenantDetails: actionStore.methods.getInfoEmpresa().tenantId,
          usuarioTenantId: idUser,
          activo: "si"
        })
        .then(function(response) {
          that.statusCreated = true;
          that.statusLoader = false;

          that.fillTable();
          //console.log('from success...');
          //console.log(response);
        })
        .catch(function(error) {
          console.log(error.message);
          //console.log('from error...2');
          if (error.response.status == 400) {
            that.statusFailure = true;
            that.statusLoader = false;
          }
        });
    },

    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${year}-${month}-${day}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    }
  }
};
</script>
